import { getSearchParams, PackagePickerSteps } from '@wix/package-picker-shared';
import React, { useEffect } from 'react';
import { useAnonymous } from '../hooks';
import { useInitLayoutBiEvents } from '../hooks/bi-hooks';
import { useValidateCycle, useValidateProductId } from '../hooks/validations';
import { useCurrentModule } from './ModuleProvider';
export const RouteGuard = _ref => {
  let {
    step,
    Element
  } = _ref;
  const module = useCurrentModule();
  const {
    setSelectedProductId,
    setSelectedCycleId
  } = module.SDK.PackagePickerStore;
  const changeRoute = module.internals.hooks.useChangeRoute();
  const {
    isAnonymous
  } = useAnonymous();
  const {
    valid: isProductIdValid,
    isLoading: isProductIdLoading
  } = useValidateProductId();
  const {
    valid: isCycleValid,
    isLoading: isCycleLoading
  } = useValidateCycle();
  const {
    didInit
  } = useInitLayoutBiEvents();
  const backToSelectPlan = () => {
    setSelectedProductId(null);
    setSelectedCycleId(null);
    changeRoute(PackagePickerSteps.SELECT_PLAN);
  };
  useEffect(() => {
    const {
      productId,
      cycleId
    } = getSearchParams();
    if (step === PackagePickerSteps.ANY) {
      backToSelectPlan();
      return;
    }
    if (step === PackagePickerSteps.SELECT_PLAN) {
      setSelectedProductId(null);
      setSelectedCycleId(null);
      return;
    }
    if (isAnonymous) {
      module.internals.bi.onRedirect == null || module.internals.bi.onRedirect({
        fromStep: step,
        toStep: 'select-plan',
        reason: 'anonymous'
      });
      backToSelectPlan();
      return;
    }
    if (step === PackagePickerSteps.SELECT_CYCLE) {
      setSelectedCycleId(null);
      if (!isProductIdLoading && !isProductIdValid) {
        module.internals.bi.onRedirect == null || module.internals.bi.onRedirect({
          fromStep: step,
          toStep: 'select-plan',
          reason: 'product-id-invalid'
        });
        backToSelectPlan();
        return;
      }
    }
    if (step === PackagePickerSteps.CHECKOUT) {
      if (!isProductIdLoading && !isProductIdValid) {
        backToSelectPlan();
        return;
      }
      if (!isCycleLoading && !isCycleValid) {
        module.internals.bi.onRedirect == null || module.internals.bi.onRedirect({
          fromStep: step,
          toStep: 'select-cycle',
          reason: 'cycle-invalid'
        });
        setSelectedCycleId(null);
        changeRoute(PackagePickerSteps.SELECT_CYCLE);
        return;
      }
    }
    setSelectedProductId(productId ?? null);
    setSelectedCycleId(cycleId ?? null);
  }, [isAnonymous, step, isProductIdValid, isCycleValid, isProductIdLoading, isCycleLoading, didInit]);
  return /*#__PURE__*/React.createElement(Element, null);
};
//# sourceMappingURL=RouteGuard.js.map